import React, { useEffect, useState } from "react";
import ModalContainer, { HeadingTitle } from "../ModalContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  DownloadBoxLabelActions,
  ViewPreviousBoxActions,
} from "../../../Actions/ProductionActions";
import Loading from "../../Loading/Loading";
import DataTable from "../../DataTable/DataTable";
import { Previous_Box_Header_arr } from "../../../Assets/api";
import { toast } from "react-toastify";
import NoData from "../../Loading/NoData";
import secureLocalStorage from "react-secure-storage";

const PreviousBox = ({ close, inventory_id }) => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const dispatch = useDispatch();
  //    Previous Box state

  const { previous_box, loading } = useSelector(
    (state) => state.ShowPreviousBox
  );

  const [previous_boxList, setPreviousBox] = useState([]);

  useEffect(() => {
    dispatch(
      ViewPreviousBoxActions("inventory_view_boxes", inventory_id, token)
    );
  }, [dispatch, inventory_id, token]);

  useEffect(() => {
    if (previous_box && previous_box?.status === 1) {
      setPreviousBox(previous_box && previous_box?.data);
    }
  }, [previous_box]);

  // console.log("PREVIOUS BOX: ", previous_box);

  // Download Box Label Code Starts here
  // Box Label state
  const { box_label, loading: download_box_label_loading } = useSelector(
    (state) => state.boxLabel
  );

  const [isDownloaded, setIsDownloaded] = useState(false);

  const handleDownloadBoxLabel = (i) => {
    setIsDownloaded(true);
    dispatch(
      DownloadBoxLabelActions(
        "inventory_get_box_label_pdf",
        inventory_id,
        i,
        token
      )
    );
  };

  useEffect(() => {
    if (box_label && box_label?.status === 1 && isDownloaded) {
      let pdfFile = box_label && box_label?.pdf_file;
      if (pdfFile && pdfFile !== "") {
        window.open(pdfFile, "_blank", "noopener,noreferrer");
      } else {
        toast.error("No PDF File Found");
      }
    } else if (box_label && box_label?.status === 0 && isDownloaded) {
      toast.error(box_label && box_label?.msg);
    }
  }, [box_label, isDownloaded]);

  // Modal Code starts here
  const [isIndex, setIsIndex] = useState(null);

  const handleModal = (index) => {
    setIsIndex(index);
  };

  const closeModal = () => {
    setIsIndex(null);
  };

  const [box_id, setBoxId] = useState("");

  const renderModal = () => {
    if (isIndex !== null) {
      return (
        <ModalContainer
          Isopen={true}
          index={isIndex}
          closeModal={closeModal}
          onData={closeModal}
          inventory_id={inventory_id}
          box_id={box_id}
        />
      );
    }
    return null;
  };
  // Modal Code ends here

  // HandleProducts Modal
  const handleProducts = (id) => {
    setBoxId(id);
    handleModal(2);
  };

  return (
    <>
      <HeadingTitle
        title={"View Previous Box"}
        center={false}
        closeModal={close}
      />
      <div className="inventory-wrapper">
        {previous_boxList && previous_boxList?.length > 0 ? (
          <div className="table-wrapper-pagination">
            <div className="table-container-pagination">
              {loading ? (
                <Loading
                  loading={loading}
                  color={"rgba(1, 18, 34, 1)"}
                  size={42}
                />
              ) : (
                <>
                  <DataTable
                    items_per_page={10}
                    page={1}
                    header={Previous_Box_Header_arr}
                    previous_Boxes={previous_boxList && previous_boxList}
                    handleDownloadBoxLabel={handleDownloadBoxLabel}
                    download_box_label_loading={download_box_label_loading}
                    handleProducts={handleProducts}
                  />
                </>
              )}
            </div>
          </div>
        ) : (
          <NoData title={"No Boxes Found"} />
        )}
      </div>
      {renderModal()}
    </>
  );
};

export default PreviousBox;
